import classNames from 'classnames';
import React, { useState } from 'react';

import styles from './Tag.module.css';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  isActive: boolean;
}

export const Tag: React.FC<Props> = ({
  children,
  className,
  isActive,
  onChange,
  ...rest
}) => {
  return (
    <span className={classNames(styles.tag, isActive && styles.active, className)} {...rest}>
      {children}
    </span>
  );
};
